import client from '../httpClient';

const defaultOption = {
  isShowLoading: false,
  isShowMessage: true,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

// 【customer019】顧客カード登録
/**
 * @param {Record<string, any>} params
 */
const customerPostCardsApi = async (params) => {
  const formData = new FormData();
  formData.append('customerId', params.customerId);
  formData.append('fileData', params.fileData.file, params.fileData.fileName);
  formData.append('fileName', params.fileData.fileName);
  formData.append('registrationDate', params.registrationDate);
  const result = await client.post('/customers/card', formData, { ...defaultOption });
  return result;
};

export default customerPostCardsApi;
